// ================= OPTION A: Single image with offset hairline frame =================
import React, { useEffect, useRef, useState } from "react";
import styles from "./CateringSection.module.css";
import { useNavigate } from "react-router-dom";

const CATERING_MAIN = "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/Website%20Images/Home%20page%20(1).jpg";

const OCCASIONS = [
    "Curated Private Dinners",
    "Elegant Weddings",
    "Corporate Events",
    "Grand Social Gatherings",
];

const CateringSection = () => {
    const sectionRef = useRef(null);
    const [visible, setVisible] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setVisible(true);
            },
            { threshold: 0.15 }
        );

        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    const navigateToContacts = () => {
        navigate("/contact");
    };

    return (
        <section
            ref={sectionRef}
            className={`${styles.wrapper} ${visible ? styles.show : ""}`}
        >
            <div className={styles.container}>
                <div className={styles.grid}>

                    {/* ===== CONTENT COLUMN ===== */}
                    <div className={styles.content}>
                        <p className={`${styles.eyebrow} ${styles.fade}`}>
                            Private Dining &amp; Catering
                        </p>

                        <h2 className={`${styles.title} ${styles.fade} ${styles.d1}`}>
                            Baglami At <br /> Your Venue
                        </h2>

                        <p className={`${styles.desc} ${styles.fade} ${styles.d2}`}>
                            Bring the signature Baglami experience to your celebration. Our
                            team curates bespoke culinary experiences tailored to your
                            occasion &mdash; with thoughtfully crafted menus, impeccable
                            service, and attention to every detail, we transform every event
                            into an unforgettable celebration, wherever you choose to host it.
                        </p>

                        <ul className={styles.occasionList}>
                            {OCCASIONS.map((item, index) => (
                                <li
                                    key={index}
                                    className={styles.fade}
                                    style={{ transitionDelay: `${450 + index * 120}ms` }}
                                >
                                    <span className={styles.occasionIndex}>
                                        {String(index + 1).padStart(2, "0")}
                                    </span>
                                    <span className={styles.occasionName}>{item}</span>
                                </li>
                            ))}
                        </ul>

                        <button
                            onClick={navigateToContacts}
                            className={`${styles.planBtn} ${styles.fade} ${styles.d5}`}
                        >
                            Plan Your Event
                        </button>
                    </div>

                    {/* ===== IMAGE COLUMN ===== */}
                    <div className={styles.imageColumn}>
                        <div className={styles.imageFrame}>
                            <img src={CATERING_MAIN} alt="Baglami private dining table spread" />
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default CateringSection;